import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { getCities } from 'models/cities'; // Importing getCities function from cities model
import { getTags } from 'models/tags'; // Importing getTags function from tags model
import { getPositions } from 'models/positions'; // Importing getPositions function from positions model
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix

/**
 * FilterPerfilView class extending JetView for creating a filter form.
 */
export default class FilterPerfilView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        const left = {
            // Left section of the form
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Text input for description
                            name: 'Description',
                            label: "<span class='icon-file-text1'></span>" + _('Descripción'), // Label with icon
                            labelPosition: 'top',
                            placeholder: _('Descripción'), // Placeholder text
                            invalidMessage: _('Descripción is required'), // Validation message
                        },
                        { id: 'grav2', gravity: 2 }, // Spacer with gravity
                    ],
                },
            ],
        };

        const upper_section = {
            // Upper section containing the left part
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Including left section
                },
            ],
        };

        const buttons = {
            // Button section for actions
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Spacer with gravity
                        {
                            view: 'button', // Clear button
                            value: _('Limpiar'), // Button label
                            width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                            minWidth: 200,
                            click: () => {
                                // Click event to clear the form
                                this.getRoot().clear();
                            },
                        },
                        {
                            view: 'button', // Consult button
                            value: _('Consultar'), // Button label
                            type: 'form', // Button type
                            width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                            minWidth: 200,
                            click: () => {
                                // Click event to submit the form
                                const filterdata = this.getRoot().getValues(); // Get form values
                                this.app.callEvent('perfil:filter', [filterdata]); // Trigger filter event with data
                            },
                        },
                    ],
                },
            ],
        };

        return {
            // Returning the complete form configuration
            view: 'form',
            rows: [upper_section, buttons], // Including upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        webix.ready(function () {
            // Ensures the DOM is ready
            if (screen.width < 500) {
                // Conditional logic for small screens
                $$('grav').hide(); // Hiding spacer for small screens
                $$('grav2').hide(); // Hiding second spacer for small screens
            }
        });
    }
}

// FILE DOCUMENTED
